import { selectAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { variantFilled, variantFlushed, variantOutlined } from '../../focusShim';
const {
  definePartsStyle,
  defineMultiStyleConfig
} = createMultiStyleConfigHelpers(selectAnatomy.keys);
const pill = definePartsStyle(props => {
  const filledVariant = props.theme.components.Select.variants.filled(props);
  return {
    field: Object.assign({}, filledVariant.field, {
      borderRadius: 'full',
      fontWeight: 'semibold',
      _focus: variantFilled()
    })
  };
});
const filled = definePartsStyle(() => {
  return {
    field: {
      _focus: variantFilled()
    }
  };
});
const outline = definePartsStyle(() => {
  return {
    field: {
      _focus: variantOutlined()
    }
  };
});
const flushed = definePartsStyle(() => {
  return {
    field: {
      _focus: variantFlushed()
    }
  };
});
export const selectTheme = defineMultiStyleConfig({
  variants: {
    pill,
    filled,
    outline,
    flushed
  }
});